module.exports = __webpack_public_path__ + "media/src/assets/images/img-travel-okinawa-73e7f9948b3184e85320b0b9a8a10abf.png";